import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"

export const LEAD_WORKSPACE_TAB_PARAM = "tab"

export const resolveLeadWorkspaceTabKey = <Key extends string>(
  tabs: readonly { key: Key }[],
  requested: string | null
): Key =>
  tabs.find((tab) => tab.key === requested)?.key ?? (tabs[0]?.key as Key)

export function useLeadWorkspaceTab<Key extends string>(
  tabs: readonly { key: Key }[]
) {
  const [searchParams, setSearchParams] = useSearchParams()

  const activeKey = resolveLeadWorkspaceTabKey(
    tabs,
    searchParams.get(LEAD_WORKSPACE_TAB_PARAM)
  )

  const setActiveKey = useCallback(
    (key: string) => {
      // `replace`, not push: a tab is a view of the same lead, not a place
      // you navigate to. Pushing made every tab click a history entry, so the
      // workspace's Back button walked back through Overview/Documents/
      // Activity before it ever reached the list the lead was opened from.
      setSearchParams(
        (prev) => {
          prev.set(LEAD_WORKSPACE_TAB_PARAM, key)
          return prev
        },
        { replace: true }
      )
    },
    [setSearchParams]
  )

  return { activeKey, setActiveKey }
}
